import CheckmarkIcon from '@assets/icons/checkmark.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { OrderInvoiceCheckInFieldsFragment } from '@/types';
import { StyleProp, Text, TextStyle, View } from 'react-native';

interface Props {
  existingCheckIn?: OrderInvoiceCheckInFieldsFragment | null;
  labelStyle?: StyleProp<TextStyle>;
}

export const CheckInLabel: React.FC<Props> = ({
  existingCheckIn,
  labelStyle,
}) => {
  const [styles, theme] = useStyles();

  let existingCheckInLabel = i18n.t('check_in.status.ready');
  let iconBackgroundColor = theme.sk.color.icon.tertiary;
  if (existingCheckIn?.completed_at) {
    existingCheckInLabel = i18n.t('check_in.status.completed');
    iconBackgroundColor = theme.sk.color.icon.positive.primary;
  } else if (existingCheckIn) {
    existingCheckInLabel = i18n.t('check_in.status.started');
    iconBackgroundColor = theme.sk.color.icon.warning.primary;
  }

  return (
    <View style={styles.base}>
      <View style={[styles.icon, { backgroundColor: iconBackgroundColor }]}>
        <CheckmarkIcon
          height={12}
          stroke={theme.sk.color.icon.ondark}
          testID="order-status-icon"
          width={12}
        />
      </View>
      <Text style={[styles.label, labelStyle]}>{existingCheckInLabel}</Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  icon: {
    alignItems: 'center',
    borderRadius: 16,
    height: 16,
    justifyContent: 'center',
    marginRight: 4,
    width: 16,
  },
  label: {
    ...FONTS.primaryBold,
    color: theme.colors.inactiveText,
    fontSize: theme.fontSizes.xsmall,
    textTransform: 'uppercase',
  },
}));
